import React from 'react';
import PropType from 'prop-types';

import PageSection from '../components/PageSection';
import ShopifyProducts from '../components/ShopifyProducts';
import shopifyConfigType from '../proptypes/shopify-config';

const ShopifyProductsSection = ({
  config, collectionId, count, title, theme, linkText,
}) => (
  <PageSection theme={theme} className="shopify-products-section">
    <h3 className="shopify-products-section__header">{title}</h3>
    <ShopifyProducts
      config={config}
      collectionId={collectionId}
      count={count}
      linkText={linkText}
    />
  </PageSection>
);

ShopifyProductsSection.propTypes = {
  config: shopifyConfigType.isRequired,
  collectionId: PropType.string.isRequired,
  count: PropType.number.isRequired,
  title: PropType.string.isRequired,
  theme: PropType.string,
  linkText: PropType.string,
};

ShopifyProductsSection.defaultProps = {
  theme: 'dark_navy',
  linkText: undefined,
};

export default ShopifyProductsSection;
